import { useMutation } from 'react-query'
import request from '../../request'

export const usePostAgencyReportGenerator = () => {
  return useMutation(({ agency_id, data }: { agency_id: number; data: any }) =>
    request({
      url: `/agencies/${agency_id}/reports/exports`,
      method: 'POST',
      data,
    }),
  )
}
